module.exports = __webpack_public_path__ + "img/bg_1440_0_1014.d9564570.jpg";